import React from "react";
import AbstractTextInput from "./AbstractTextInput";
import Rules from "../../../../../config/rules";
import {ValidatorForm} from "react-material-ui-form-validator";

class EmailInput extends AbstractTextInput {

    label = "E-mail";


    componentDidMount() {
        if (this.props.confirmEmail !== undefined ) ValidatorForm.addValidationRule('isEmailMatch', this.isEmailMatch);
        ValidatorForm.addValidationRule('isNotUnipMail', this.isNotUnipMail)
    }

    componentWillUnmount() {
        if (this.props.confirmEmail !== undefined ) ValidatorForm.removeValidationRule('isEmailMatch');
        ValidatorForm.removeValidationRule('isNotUnipMail');
    }

    isNotUnipMail = (value) => {
        value = value.replace(/ /gi, '');
        if (Rules.isValidEmail(value)) {
            return !(/(.*\.)?@uniprevoyance\.*/.test(value));
        }
    }

    isEmailMatch = (value) => {
        value = value.replace(/ /gi, '');
        if (this.props.confirmEmail) {
            if (Rules.isValidEmail(value)) {
                return value === this.props.confirmEmail;
            }
        } else {
            return true
        }

    }

    getValidatorsByCase = () => {
        if (!this.props.isOptional) {
            return this.props.confirmEmail === undefined ? ['required', 'isEmail', 'isNotUnipMail'] : ['required', 'isEmail', 'isNotUnipMail', 'isEmailMatch']
        } else {
            return this.props.confirmEmail === undefined  ? ['isEmail', 'isNotUnipMail']: ['isEmail', 'isNotUnipMail', 'isEmailMatch']
        }
    }

    getErrorMessagesByCase = () => {
        if (!this.props.isOptional) {
            return this.props.confirmEmail === undefined ? [Rules.txtRequis, Rules.txtInvalidEmail, Rules.txtIsUnipMail] : [Rules.txtRequis, Rules.txtInvalidEmail, Rules.txtIsUnipMail, Rules.txtisEmailMatch]
        } else {
            return this.props.confirmEmail === undefined ? [Rules.txtInvalidEmail, Rules.txtIsUnipMail]: [Rules.txtInvalidEmail, Rules.txtIsUnipMail, Rules.txtisEmailMatch]
        }
    }

    validators = this.getValidatorsByCase();

    errorMessages = this.getErrorMessagesByCase();

    specs = {
        textTransform : 'lowercase',
        autoComplete: 'new-password',
        form: {
            autoComplete: 'off',
        },
        helperText: '',
        inputProps: {
            maxLength: 150,
            autoComplete: 'off'
        }
    }
}


export default EmailInput;
